import type { Color } from "@corca/data";
import type { Editor } from "@tiptap/react";

export { BlockStyle, BLOCK_STYLE_TYPES } from "@corca/tiptap";

export function getBlockBackgroundColor(editor: Editor): Color | null {
  const { state } = editor.view;
  const { from } = state.selection;
  const pos = state.doc.resolve(from);

  // Start from the current node and traverse up to find the closest parent with color attribute
  for (let { depth } = pos; depth >= 0; depth--) {
    const node = pos.node(depth);
    const { color } = node.attrs as { color?: Color };
    if (color) {
      return color;
    }
  }

  return null;
}
